export {
  MorphemeDetailsTileUi,
  type MorphemeDetailsTileUiProps,
} from "#morpheme-details-tile-ui";
// Re-exported so sibling card tiles can compose the glyph and gloss without
// reaching into the private `_section.*` packages (encapsulation boundary).
export {
  MorphemeDetailsTileGlossSection,
  MorphemeDetailsTileGlyph,
} from "#morpheme-details-tile-sections";
